import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { MainService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QueryAnalyzerService {

  constructor(private _http: HttpClient, private mainService: MainService) { }

  apiURL = environment.QUERY_ANALYZER_V2_API;

  createAnalysis(query: string): Observable<any> {
    let payload = JSON.stringify({
      query
    });

    let analysis = this._http.post(this.apiURL + '/analysis/', payload , this.mainService.httpOptions).pipe(
      map(analysis => {
          analysis["created_at"] = this.getFormattedDate(analysis["created_at"]);
          analysis["updated_at"] = this.getFormattedDate(analysis["updated_at"]);
          return analysis;
      }),
      catchError(this.mainService.handleError)
    );

    return analysis;
  }

  deleteAnalysis(id: string): Observable<any> {
    let analysis = this._http.delete(this.apiURL + '/analysis/' + id, this.mainService.httpOptions).pipe(
      map(analysis => {
          return analysis;
      }),
      catchError(this.mainService.handleError)
    );

    return analysis;
  }

  getAnalyses(): Observable<any[]> {
    let analyses = this._http.get<any[]>(this.apiURL + '/analysis/', this.mainService.httpOptions).pipe(
      retry(3),
      map((analysesList: any[]) => {
          analysesList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
          return analysesList.map(analysis => {
              analysis["created_at"] = this.getFormattedDate(analysis["created_at"]);
              analysis["updated_at"] = this.getFormattedDate(analysis["updated_at"]);
              return analysis;
          });
      }),
      catchError(this.mainService.handleError)
    );

    return analyses;
  } 

  getFormattedDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    return formattedDate
  }

}
